/**
 * Matches BFF / @packages/leaver-letters eligibility:
 * Resignation when reason === 'Resignation'; Retirement when reasonResignation === 'Retirement'.
 */
export function resolveLeaverLetterType(formThree) {
    if (!formThree) {
        return undefined;
    }
    if (formThree.reason === 'Resignation') {
        return 'resignation';
    }
    if (formThree.reasonResignation === 'Retirement') {
        return 'retirement';
    }
    return undefined;
}
export function isEligibleForLeaverLetter(formThree) {
    return resolveLeaverLetterType(formThree) !== undefined;
}
/**
 * Display-only From address aligned with notifications-manager SOURCE_EMAIL per environment.
 */
export function resolveLeaverLetterFromEmail(hostname = typeof window !== 'undefined'
    ? window.location.hostname
    : '') {
    if (hostname.includes('slam-uat')) {
        return 'noreply@slam-uat.equans.co.uk';
    }
    if (hostname.includes('slam.equans')) {
        return 'noreply@slam.equans.co.uk';
    }
    return 'steve.morland@leighton.com';
}
export function displayAttachedFileName(fileName) {
    const parts = fileName.split('/');
    return parts.length > 1 ? (parts[parts.length - 1] ?? fileName) : fileName;
}
export function isLeaverLetterAttachment(fileName) {
    return displayAttachedFileName(fileName).startsWith('Leaver_Letter_');
}
